import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationsDialogOptions } from './notifications-dialog';


@Component({
  selector: 'app-notifications-dialog',
  templateUrl: './notifications-dialog.component.html',
  styleUrls: ['./notifications-dialog.component.scss', '../../../../themes/table.scss']
})
export class NotificationsDialogComponent implements AfterViewInit {
    TitleText?: string;
    MessageText?: string;
    Details?: any;

    dataSource = new MatTableDataSource([]);
    dataColumns = ["StudentName", "StudentID", "ProgramsApplied", "DateUpdated"];
    displayedColumns = [...this.dataColumns, 'Actions'];

    @ViewChild(MatSort) sort: MatSort | null = null;
    
    constructor(
        private dialogRef: MatDialogRef<NotificationsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: NotificationsDialogOptions,
    ) {
        const self = this;
        self.TitleText = opts.TitleText || 'Notification Details';
        self.MessageText = opts.MessageText || '';
        self.Details = opts.Details;
    }

    ngAfterViewInit() {
        this.dataSource = new MatTableDataSource(this.Details);
        this.dataSource.sort = this.sort;
    }

    ViewApplication(event: Event, entry: any): void {
        event.preventDefault();

        this.dialogRef.close({
            StudentID: entry.StudentID,
            StudentName: entry.StudentName,
            PathwaysReferralID: entry.PathwaysReferralID
        });
    }

    OKHandler(): void {
        this.dialogRef.close(null);
    }
}
